import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

let app={
    "name":"Autoscuola Susa",
    "version":"0.20",
    "theme": {
        palette: {
            primary: { main: '#1976d2' },
          }
    },
    "localCfg":{},    
    "collections":{},
    "defaultQueryLimit":10,
    "pageSizeOptions":[10,25,50,100],
    "services":{},
    "users":null,
    "collections_config":{
        
    },
    "category":{"a":"A", "b":"B", "bauto":"B AUTO", "be":"B+E", "c":"C", "ce":"C+E", "d":"D", "de":"D+E"},
    "codeToLabel": {
        "equalTo":"Ricerca esatta",
        "startBy":"Inizia per",
        "lowerThan":"Minore di",
        "greaterThan":"Maggiore di",
        "lowerEqualThan":"Minore uguale a",
        "greaterEqualThan":"Maggiore uguale a",
        "includedBy":"Compreso tra",
    },
    "durate": {
        30:"30 minuti",
        50:"50 minuti",
        60:"1 ora",
        90:"1 ora e 30 minuti",
        120:"2 ore",
        150:"2 ore e 30 minuti",
        180:"3 ore",
    },
    "filterByType": {
        "select":["equalTo"],
        "boolean":["equalTo"],
        "text":["startBy","equalTo"],
        "number":["equalTo","lowerThan","greaterThan","lowerEqualThan","greaterEqualThan"],
        "date":["equalTo","lowerThan","greaterThan","lowerEqualThan","greaterEqualThan"],
        "datetime":["equalTo","lowerThan","greaterThan","lowerEqualThan","greaterEqualThan"]
    },
    "externalLogService":"https://susa.ingsoftware.it/serv.php?req=SusaGuideLog",
    "log":{
        "currentArray":[],
        "lastLogDate":null,
        "minimumLogTrasmissionInterval":1000*30*1, // 10 secondi
    }

};
app.services["getCreationDatetime"]={
    "async":false,
    "func":function (item,value) {
        return new Date();
    }
}
const RapidAction =(props) => {

    return (<>
    <ListItemButton to={props.target} component={Link} state={props.state}>
    <ListItemIcon>
      {props.Icon}
    </ListItemIcon>
    <ListItemText primary={props.label} />
  </ListItemButton></>)
}


app.ruoli={
    "admin":{
        "name":"Amministratore",
        "capabilities": {
            
            "*": {
                "can_add":true,
                "can_edit":true,
                "can_del":true,
                "can_view":true,
                "show_action":true,
                "can_admin":true
            },
            
            "guide":{
                "can_add":false,
                "can_edit":false,
                "can_del":false,
                "can_view":true,
                "show_action":true,
                "actionsToView":["view","delete"],
                "can_admin":false
            },                
        },
        "rapidActions": [
            <RapidAction Icon={<SupportAgentIcon/>} label="Vai ai Candidati" target="/candidati/" state= {{ data: {callerUrl:"/dashboard" }}}/>,
            <RapidAction Icon={<AddIcon/>} label="Nuovo Candidato" target="/candidati/update" state= {{ data: {callerUrl:"/dashboard" }}}/>,
            <RapidAction Icon={<DirectionsCarIcon/>} label="Vai a Guide" target="/guide" state= {{ data: {callerUrl:"/dashboard" }}}/>


        ],
        "menuToHide":[],
    },
    "ufficio":{
        "name":"Ufficio",
        "capabilities":{
            "*": {
                "can_add":false,
                "can_edit":false,
                "can_del":false,
                "can_view":true,
                "show_action":true,
                "can_admin":false
                
            },
                "utenti": {
                    "can_add":true,
                    "can_edit":true,
                    "can_del":false,
                    "can_view":true,
                    "show_action":true,
                    "can_admin":false
                },
                "candidati":{
                    "can_add":true,
                    "can_edit":true,
                    "can_del":true,
                    "can_view":true,
                    "show_action":true,
                    "can_admin":false
                },
                "guide":{
                    "can_add":false,
                    "can_edit":false,
                    "can_del":false,
                    "can_view":true,
                    "show_action":true,
                    "actionsToView":["view"],
                    "can_admin":false
                },                
                "pagamenti":{
                    "can_add":true,
                    "can_edit":true,
                    "can_del":false,
                    "can_view":true,
                    "show_action":true,
                    "can_admin":false
                },
            
            },
            "rapidActions": [
                <RapidAction Icon={<SupportAgentIcon/>} label="Vai ai Candidati" target="/candidati/" state= {{ data: {callerUrl:"/dashboard" }}}/>,
                <RapidAction Icon={<AddIcon/>} label="Nuovo Candidato" target="/candidati/update" state= {{ data: {callerUrl:"/dashboard" }}}/>,
                <RapidAction Icon={<DirectionsCarIcon/>} label="Vai a Guide" target="/guide" state= {{ data: {callerUrl:"/dashboard" }}}/>


            ],
            "menuToHide":[],
    },
    "istruttore":{
        "name":"Istruttore",
        "capabilities":{
            "*": {
                "can_add":false,
                "can_edit":false,
                "can_del":false,
                "can_view":false,
                "show_action":false
            },               
                "candidati":{
                    "can_add":true,
                    "can_edit":false,
                    "can_del":false,
                    "can_view":true,
                    "show_action":true
                },                
                "guide":{
                    "can_add":false,
                    "can_edit":false,
                    "can_del":false,
                    "can_view":true,
                    
                    "show_action":true,
                    "actionsToView":["view"],
                },               
                "utenti":{
                    "can_add":false,
                    "can_edit":false,
                    "can_del":false,
                    "can_view":true,
                    "show_action":false
                },   
            
        },
            "rapidActions": [
                <RapidAction Icon={<DirectionsCarIcon/>} label="Vai a Guide" target="/guide" state= {{ data: {callerUrl:"/dashboard" }}}/>
    
    
            ],
            "menuToHide":["utenti","candidati"],
    }
}
export {app};